import { NotificationsNotificationsSessionDto } from '@mi-front/api-v2';
import { useQuery } from '@tanstack/react-query';
import { fetchNotificationsSession } from './fetch-notifications-session';

export const notificationsSessionQueryKey = ['notifications', 'session'] as const;

/**
 * Loads the notifications provider session; refetches before the token expires.
 */
export function useNotificationsSession(enabled = true) {
  return useQuery({
    queryKey: notificationsSessionQueryKey,
    queryFn: fetchNotificationsSession,
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 1,
    /**
     * Refetch slightly before the signed user token expires (default TTL 3600s).
     */
    refetchInterval: (query) => {
      const data = query.state.data as NotificationsNotificationsSessionDto | undefined;
      if (!data?.expiresInSeconds) {
        return false;
      }
      const refreshMs = Math.max((data.expiresInSeconds - 60) * 1000, 30_000);
      return refreshMs;
    },
  });
}
